import { render, staticRenderFns } from "./FinanceStatusBadge.vue?vue&type=template&id=0d8c96c4&"
import script from "./FinanceStatusBadge.vue?vue&type=script&lang=js&"
export * from "./FinanceStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports